import { ForwardRefExoticComponent } from 'react';

import WrapperMockComponent from '@hh.ru/magritte-ui-icon/WrapperMockComponent';
import { mockComponent } from '@hh.ru/magritte-ui-mock-component';

export { type IconColor, type IconDisabledColor } from '@hh.ru/magritte-ui-icon/types';

export const IconDynamic: ForwardRefExoticComponent<Record<string, unknown>> = mockComponent('IconDynamic', undefined, {
    withChildren: true,
});
export const AdjustmentsFilledSize16 = mockComponent(
    'AdjustmentsFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AdjustmentsFilledSize24 = mockComponent(
    'AdjustmentsFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AdjustmentsOutlinedSize16 = mockComponent(
    'AdjustmentsOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AdjustmentsOutlinedSize24 = mockComponent(
    'AdjustmentsOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AntennaFilledSize16 = mockComponent(
    'AntennaFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AntennaFilledSize24 = mockComponent(
    'AntennaFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AntennaOutlinedSize16 = mockComponent(
    'AntennaOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AntennaOutlinedSize24 = mockComponent(
    'AntennaOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArchiveboxArrowFilledSize16 = mockComponent(
    'ArchiveboxArrowFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArchiveboxArrowFilledSize24 = mockComponent(
    'ArchiveboxArrowFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArchiveboxArrowOutlinedSize16 = mockComponent(
    'ArchiveboxArrowOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArchiveboxArrowOutlinedSize24 = mockComponent(
    'ArchiveboxArrowOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArchiveboxFilledSize16 = mockComponent(
    'ArchiveboxFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArchiveboxFilledSize24 = mockComponent(
    'ArchiveboxFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArchiveboxOutlinedSize16 = mockComponent(
    'ArchiveboxOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArchiveboxOutlinedSize24 = mockComponent(
    'ArchiveboxOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDiagonalLeftDownOutlinedSize16 = mockComponent(
    'ArrowDiagonalLeftDownOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDiagonalLeftDownOutlinedSize24 = mockComponent(
    'ArrowDiagonalLeftDownOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDiagonalLeftUpOutlinedSize16 = mockComponent(
    'ArrowDiagonalLeftUpOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDiagonalLeftUpOutlinedSize24 = mockComponent(
    'ArrowDiagonalLeftUpOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDiagonalRightDownOutlinedSize16 = mockComponent(
    'ArrowDiagonalRightDownOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDiagonalRightDownOutlinedSize24 = mockComponent(
    'ArrowDiagonalRightDownOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDiagonalRightUpOutlinedSize16 = mockComponent(
    'ArrowDiagonalRightUpOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDiagonalRightUpOutlinedSize24 = mockComponent(
    'ArrowDiagonalRightUpOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDownLineOutlinedSize16 = mockComponent(
    'ArrowDownLineOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDownLineOutlinedSize24 = mockComponent(
    'ArrowDownLineOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDownOutlinedSize16 = mockComponent(
    'ArrowDownOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDownOutlinedSize24 = mockComponent(
    'ArrowDownOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDownRightOutlinedSize16 = mockComponent(
    'ArrowDownRightOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowDownRightOutlinedSize24 = mockComponent(
    'ArrowDownRightOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowLeftOutlinedSize16 = mockComponent(
    'ArrowLeftOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowLeftOutlinedSize24 = mockComponent(
    'ArrowLeftOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowLeftRightOutlinedSize16 = mockComponent(
    'ArrowLeftRightOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowLeftRightOutlinedSize24 = mockComponent(
    'ArrowLeftRightOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowPathClockwiseOutlinedSize16 = mockComponent(
    'ArrowPathClockwiseOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowPathClockwiseOutlinedSize24 = mockComponent(
    'ArrowPathClockwiseOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowPathOutlinedSize16 = mockComponent(
    'ArrowPathOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowPathOutlinedSize24 = mockComponent(
    'ArrowPathOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowRightOutlinedSize16 = mockComponent(
    'ArrowRightOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowRightOutlinedSize24 = mockComponent(
    'ArrowRightOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowSquareOutlinedSize16 = mockComponent(
    'ArrowSquareOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowSquareOutlinedSize24 = mockComponent(
    'ArrowSquareOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowUpDownOutlinedSize16 = mockComponent(
    'ArrowUpDownOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowUpDownOutlinedSize24 = mockComponent(
    'ArrowUpDownOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowUpOutlinedSize16 = mockComponent(
    'ArrowUpOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowUpOutlinedSize24 = mockComponent(
    'ArrowUpOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowUpOutlinedSize32 = mockComponent(
    'ArrowUpOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowsCrossOutlinedSize16 = mockComponent(
    'ArrowsCrossOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowsCrossOutlinedSize24 = mockComponent(
    'ArrowsCrossOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowsDiagonalInOutlinedSize16 = mockComponent(
    'ArrowsDiagonalInOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowsDiagonalInOutlinedSize24 = mockComponent(
    'ArrowsDiagonalInOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowsDiagonalOutOutlinedSize16 = mockComponent(
    'ArrowsDiagonalOutOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ArrowsDiagonalOutOutlinedSize24 = mockComponent(
    'ArrowsDiagonalOutOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AstrostarFilledSize16 = mockComponent(
    'AstrostarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AstrostarFilledSize24 = mockComponent(
    'AstrostarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AstrostarOutlinedSize16 = mockComponent(
    'AstrostarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const AstrostarOutlinedSize24 = mockComponent(
    'AstrostarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BackwardFilledSize16 = mockComponent(
    'BackwardFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BackwardFilledSize24 = mockComponent(
    'BackwardFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BackwardOutlinedSize16 = mockComponent(
    'BackwardOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BackwardOutlinedSize24 = mockComponent(
    'BackwardOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BagFilledSize16 = mockComponent(
    'BagFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BagFilledSize24 = mockComponent(
    'BagFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BagOutlinedSize16 = mockComponent(
    'BagOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BagOutlinedSize24 = mockComponent(
    'BagOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BagPlusFilledSize16 = mockComponent(
    'BagPlusFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BagPlusFilledSize24 = mockComponent(
    'BagPlusFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BagPlusOutlinedSize16 = mockComponent(
    'BagPlusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BagPlusOutlinedSize24 = mockComponent(
    'BagPlusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BanFilledSize16 = mockComponent(
    'BanFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BanFilledSize24 = mockComponent(
    'BanFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BanOutlinedSize16 = mockComponent(
    'BanOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BanOutlinedSize24 = mockComponent(
    'BanOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BankFilledSize16 = mockComponent(
    'BankFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BankFilledSize24 = mockComponent(
    'BankFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BankOutlinedSize16 = mockComponent(
    'BankOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BankOutlinedSize24 = mockComponent(
    'BankOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BarsOutlinedSize16 = mockComponent(
    'BarsOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BarsOutlinedSize24 = mockComponent(
    'BarsOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BellCrossedFilledSize16 = mockComponent(
    'BellCrossedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BellCrossedFilledSize24 = mockComponent(
    'BellCrossedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BellCrossedOutlinedSize16 = mockComponent(
    'BellCrossedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BellCrossedOutlinedSize24 = mockComponent(
    'BellCrossedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BellFilledSize16 = mockComponent(
    'BellFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BellFilledSize24 = mockComponent(
    'BellFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BellOutlinedSize16 = mockComponent(
    'BellOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BellOutlinedSize24 = mockComponent(
    'BellOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BicycleOutlinedSize16 = mockComponent(
    'BicycleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BicycleOutlinedSize24 = mockComponent(
    'BicycleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BoltFilledSize16 = mockComponent(
    'BoltFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BoltFilledSize24 = mockComponent(
    'BoltFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BoltOutlinedSize16 = mockComponent(
    'BoltOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BoltOutlinedSize24 = mockComponent(
    'BoltOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BookFilledSize16 = mockComponent(
    'BookFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BookFilledSize24 = mockComponent(
    'BookFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BookOutlinedSize16 = mockComponent(
    'BookOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BookOutlinedSize24 = mockComponent(
    'BookOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BotFilledSize16 = mockComponent(
    'BotFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BotFilledSize24 = mockComponent(
    'BotFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BotOutlinedSize16 = mockComponent(
    'BotOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BotOutlinedSize24 = mockComponent(
    'BotOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BottleFilledSize16 = mockComponent(
    'BottleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BottleFilledSize24 = mockComponent(
    'BottleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BottleOutlinedSize16 = mockComponent(
    'BottleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BottleOutlinedSize24 = mockComponent(
    'BottleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BoxFilledSize16 = mockComponent(
    'BoxFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BoxFilledSize24 = mockComponent(
    'BoxFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BoxOutlinedSize16 = mockComponent(
    'BoxOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BoxOutlinedSize24 = mockComponent(
    'BoxOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BracketsOutlinedSize16 = mockComponent(
    'BracketsOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BracketsOutlinedSize24 = mockComponent(
    'BracketsOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BricksFilledSize16 = mockComponent(
    'BricksFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BricksFilledSize24 = mockComponent(
    'BricksFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BricksOutlinedSize16 = mockComponent(
    'BricksOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BricksOutlinedSize24 = mockComponent(
    'BricksOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BriefcaseFilledSize16 = mockComponent(
    'BriefcaseFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BriefcaseFilledSize24 = mockComponent(
    'BriefcaseFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BriefcaseOutlinedSize16 = mockComponent(
    'BriefcaseOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BriefcaseOutlinedSize24 = mockComponent(
    'BriefcaseOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleDotRoundFilledSize16 = mockComponent(
    'BubbleDotRoundFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleDotRoundFilledSize24 = mockComponent(
    'BubbleDotRoundFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleDotRoundOutlinedSize16 = mockComponent(
    'BubbleDotRoundOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleDotRoundOutlinedSize24 = mockComponent(
    'BubbleDotRoundOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundDoubleFilledSize16 = mockComponent(
    'BubbleRoundDoubleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundDoubleFilledSize24 = mockComponent(
    'BubbleRoundDoubleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundDoubleOutlinedSize16 = mockComponent(
    'BubbleRoundDoubleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundDoubleOutlinedSize24 = mockComponent(
    'BubbleRoundDoubleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundFilledSize16 = mockComponent(
    'BubbleRoundFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundFilledSize24 = mockComponent(
    'BubbleRoundFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundHyperstarFilledSize16 = mockComponent(
    'BubbleRoundHyperstarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundHyperstarFilledSize24 = mockComponent(
    'BubbleRoundHyperstarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundHyperstarOutlinedSize16 = mockComponent(
    'BubbleRoundHyperstarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundHyperstarOutlinedSize24 = mockComponent(
    'BubbleRoundHyperstarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundOutlinedSize16 = mockComponent(
    'BubbleRoundOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleRoundOutlinedSize24 = mockComponent(
    'BubbleRoundOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleSquareFilledSize16 = mockComponent(
    'BubbleSquareFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleSquareFilledSize24 = mockComponent(
    'BubbleSquareFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleSquareOutlinedSize16 = mockComponent(
    'BubbleSquareOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BubbleSquareOutlinedSize24 = mockComponent(
    'BubbleSquareOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BuildingFilledSize16 = mockComponent(
    'BuildingFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BuildingFilledSize24 = mockComponent(
    'BuildingFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BuildingOutlinedSize16 = mockComponent(
    'BuildingOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BuildingOutlinedSize24 = mockComponent(
    'BuildingOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BulletFilledSize16 = mockComponent(
    'BulletFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BulletFilledSize24 = mockComponent(
    'BulletFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BulletOutlinedSize16 = mockComponent(
    'BulletOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BulletOutlinedSize24 = mockComponent(
    'BulletOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BusFilledSize16 = mockComponent(
    'BusFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BusFilledSize24 = mockComponent(
    'BusFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BusOutlinedSize16 = mockComponent(
    'BusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BusOutlinedSize24 = mockComponent(
    'BusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BusTaxiFilledSize16 = mockComponent(
    'BusTaxiFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BusTaxiFilledSize24 = mockComponent(
    'BusTaxiFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BusTaxiOutlinedSize16 = mockComponent(
    'BusTaxiOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const BusTaxiOutlinedSize24 = mockComponent(
    'BusTaxiOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CalendarFilledSize16 = mockComponent(
    'CalendarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CalendarFilledSize24 = mockComponent(
    'CalendarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CalendarOutlinedSize16 = mockComponent(
    'CalendarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CalendarOutlinedSize24 = mockComponent(
    'CalendarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CameraFilledSize16 = mockComponent(
    'CameraFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CameraFilledSize24 = mockComponent(
    'CameraFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CameraOutlinedSize16 = mockComponent(
    'CameraOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CameraOutlinedSize24 = mockComponent(
    'CameraOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CarDoorFilledSize16 = mockComponent(
    'CarDoorFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CarDoorFilledSize24 = mockComponent(
    'CarDoorFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CarDoorOutlinedSize16 = mockComponent(
    'CarDoorOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CarDoorOutlinedSize24 = mockComponent(
    'CarDoorOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CarFilledSize16 = mockComponent(
    'CarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CarFilledSize24 = mockComponent(
    'CarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CarOutlinedSize16 = mockComponent(
    'CarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CarOutlinedSize24 = mockComponent(
    'CarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesCrossFilledSize16 = mockComponent(
    'CardLinesCrossFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesCrossFilledSize24 = mockComponent(
    'CardLinesCrossFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesCrossOutlinedSize16 = mockComponent(
    'CardLinesCrossOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesCrossOutlinedSize24 = mockComponent(
    'CardLinesCrossOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesCrossedFilledSize16 = mockComponent(
    'CardLinesCrossedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesCrossedFilledSize24 = mockComponent(
    'CardLinesCrossedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesCrossedOutlinedSize16 = mockComponent(
    'CardLinesCrossedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesCrossedOutlinedSize24 = mockComponent(
    'CardLinesCrossedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesEyeFilledSize16 = mockComponent(
    'CardLinesEyeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesEyeFilledSize24 = mockComponent(
    'CardLinesEyeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesEyeOutlinedSize16 = mockComponent(
    'CardLinesEyeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesEyeOutlinedSize24 = mockComponent(
    'CardLinesEyeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesFilledSize16 = mockComponent(
    'CardLinesFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesFilledSize24 = mockComponent(
    'CardLinesFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesHeartFilledSize16 = mockComponent(
    'CardLinesHeartFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesHeartFilledSize24 = mockComponent(
    'CardLinesHeartFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesHeartOutlinedSize16 = mockComponent(
    'CardLinesHeartOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesHeartOutlinedSize24 = mockComponent(
    'CardLinesHeartOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesOutlinedSize16 = mockComponent(
    'CardLinesOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesOutlinedSize24 = mockComponent(
    'CardLinesOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesPlusFilledSize16 = mockComponent(
    'CardLinesPlusFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesPlusFilledSize24 = mockComponent(
    'CardLinesPlusFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesPlusOutlinedSize16 = mockComponent(
    'CardLinesPlusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesPlusOutlinedSize24 = mockComponent(
    'CardLinesPlusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedCrossFilledSize16 = mockComponent(
    'CardLinesStackedCrossFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedCrossFilledSize24 = mockComponent(
    'CardLinesStackedCrossFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedCrossOutlinedSize16 = mockComponent(
    'CardLinesStackedCrossOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedCrossOutlinedSize24 = mockComponent(
    'CardLinesStackedCrossOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedCrossedFilledSize16 = mockComponent(
    'CardLinesStackedCrossedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedCrossedFilledSize24 = mockComponent(
    'CardLinesStackedCrossedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedCrossedOutlinedSize16 = mockComponent(
    'CardLinesStackedCrossedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedCrossedOutlinedSize24 = mockComponent(
    'CardLinesStackedCrossedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedFilledSize16 = mockComponent(
    'CardLinesStackedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedFilledSize24 = mockComponent(
    'CardLinesStackedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedOutlinedSize16 = mockComponent(
    'CardLinesStackedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedOutlinedSize24 = mockComponent(
    'CardLinesStackedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedPlusFilledSize16 = mockComponent(
    'CardLinesStackedPlusFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedPlusFilledSize24 = mockComponent(
    'CardLinesStackedPlusFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedPlusOutlinedSize16 = mockComponent(
    'CardLinesStackedPlusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CardLinesStackedPlusOutlinedSize24 = mockComponent(
    'CardLinesStackedPlusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CartFilledSize16 = mockComponent(
    'CartFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CartFilledSize24 = mockComponent(
    'CartFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CartOutlinedSize16 = mockComponent(
    'CartOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CartOutlinedSize24 = mockComponent(
    'CartOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChartBarFilledSize16 = mockComponent(
    'ChartBarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChartBarFilledSize24 = mockComponent(
    'ChartBarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChartBarOutlinedSize16 = mockComponent(
    'ChartBarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChartBarOutlinedSize24 = mockComponent(
    'ChartBarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChartLineFilledSize16 = mockComponent(
    'ChartLineFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChartLineFilledSize24 = mockComponent(
    'ChartLineFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChartLineFilledSize32 = mockComponent(
    'ChartLineFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChartLineOutlinedSize16 = mockComponent(
    'ChartLineOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChartLineOutlinedSize24 = mockComponent(
    'ChartLineOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChartLineOutlinedSize32 = mockComponent(
    'ChartLineOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckCircleFilledSize12 = mockComponent(
    'CheckCircleFilledSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckCircleFilledSize16 = mockComponent(
    'CheckCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckCircleFilledSize24 = mockComponent(
    'CheckCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckCircleOutlinedSize12 = mockComponent(
    'CheckCircleOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckCircleOutlinedSize16 = mockComponent(
    'CheckCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckCircleOutlinedSize24 = mockComponent(
    'CheckCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckDoubleOutlinedSize12 = mockComponent(
    'CheckDoubleOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckDoubleOutlinedSize16 = mockComponent(
    'CheckDoubleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckDoubleOutlinedSize24 = mockComponent(
    'CheckDoubleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckOutlinedSize12 = mockComponent(
    'CheckOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckOutlinedSize16 = mockComponent(
    'CheckOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckOutlinedSize24 = mockComponent(
    'CheckOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronDownOutlinedSize12 = mockComponent(
    'ChevronDownOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronDownOutlinedSize16 = mockComponent(
    'ChevronDownOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronDownOutlinedSize24 = mockComponent(
    'ChevronDownOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronLeftOutlinedSize12 = mockComponent(
    'ChevronLeftOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronLeftOutlinedSize16 = mockComponent(
    'ChevronLeftOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronLeftOutlinedSize24 = mockComponent(
    'ChevronLeftOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronLeftSquareFilledSize16 = mockComponent(
    'ChevronLeftSquareFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronLeftSquareFilledSize24 = mockComponent(
    'ChevronLeftSquareFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronLeftSquareOutlinedSize16 = mockComponent(
    'ChevronLeftSquareOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronLeftSquareOutlinedSize24 = mockComponent(
    'ChevronLeftSquareOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronRightOutlinedSize12 = mockComponent(
    'ChevronRightOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronRightOutlinedSize16 = mockComponent(
    'ChevronRightOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronRightOutlinedSize24 = mockComponent(
    'ChevronRightOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronRightSquareFilledSize16 = mockComponent(
    'ChevronRightSquareFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronRightSquareFilledSize24 = mockComponent(
    'ChevronRightSquareFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronRightSquareOutlinedSize16 = mockComponent(
    'ChevronRightSquareOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronRightSquareOutlinedSize24 = mockComponent(
    'ChevronRightSquareOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronUpDownOutlinedSize12 = mockComponent(
    'ChevronUpDownOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronUpDownOutlinedSize16 = mockComponent(
    'ChevronUpDownOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronUpDownOutlinedSize24 = mockComponent(
    'ChevronUpDownOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronUpOutlinedSize12 = mockComponent(
    'ChevronUpOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronUpOutlinedSize16 = mockComponent(
    'ChevronUpOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronUpOutlinedSize24 = mockComponent(
    'ChevronUpOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronWide2OutlinedSize16 = mockComponent(
    'ChevronWide2OutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronWide2OutlinedSize24 = mockComponent(
    'ChevronWide2OutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronWide3OutlinedSize16 = mockComponent(
    'ChevronWide3OutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronWide3OutlinedSize24 = mockComponent(
    'ChevronWide3OutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronWideOutlinedSize16 = mockComponent(
    'ChevronWideOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronWideOutlinedSize24 = mockComponent(
    'ChevronWideOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CircleFilledSize16 = mockComponent(
    'CircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CircleFilledSize24 = mockComponent(
    'CircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CircleOutlinedSize16 = mockComponent(
    'CircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CircleOutlinedSize24 = mockComponent(
    'CircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClipOutlinedSize16 = mockComponent(
    'ClipOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClipOutlinedSize24 = mockComponent(
    'ClipOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClocheFilledSize16 = mockComponent(
    'ClocheFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClocheFilledSize24 = mockComponent(
    'ClocheFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClocheOutlinedSize16 = mockComponent(
    'ClocheOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClocheOutlinedSize24 = mockComponent(
    'ClocheOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockFilledSize12 = mockComponent(
    'ClockFilledSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockFilledSize16 = mockComponent(
    'ClockFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockFilledSize24 = mockComponent(
    'ClockFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockFilledSize32 = mockComponent(
    'ClockFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockOutlinedSize12 = mockComponent(
    'ClockOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockOutlinedSize16 = mockComponent(
    'ClockOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockOutlinedSize24 = mockComponent(
    'ClockOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockOutlinedSize32 = mockComponent(
    'ClockOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockRewindOutlinedSize12 = mockComponent(
    'ClockRewindOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockRewindOutlinedSize16 = mockComponent(
    'ClockRewindOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ClockRewindOutlinedSize24 = mockComponent(
    'ClockRewindOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CloudFilledSize16 = mockComponent(
    'CloudFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CloudFilledSize24 = mockComponent(
    'CloudFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CloudOutlinedSize16 = mockComponent(
    'CloudOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CloudOutlinedSize24 = mockComponent(
    'CloudOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ComputerOutlinedSize16 = mockComponent(
    'ComputerOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ComputerOutlinedSize24 = mockComponent(
    'ComputerOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ConstructionHatFilledSize16 = mockComponent(
    'ConstructionHatFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ConstructionHatFilledSize24 = mockComponent(
    'ConstructionHatFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ConstructionHatOutlinedSize16 = mockComponent(
    'ConstructionHatOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ConstructionHatOutlinedSize24 = mockComponent(
    'ConstructionHatOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CopyFilledSize16 = mockComponent(
    'CopyFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CopyFilledSize24 = mockComponent(
    'CopyFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CopyOutlinedSize16 = mockComponent(
    'CopyOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CopyOutlinedSize24 = mockComponent(
    'CopyOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CraneFilledSize16 = mockComponent(
    'CraneFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CraneFilledSize24 = mockComponent(
    'CraneFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CraneOutlinedSize16 = mockComponent(
    'CraneOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CraneOutlinedSize24 = mockComponent(
    'CraneOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CrossCircleFilledSize16 = mockComponent(
    'CrossCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CrossCircleFilledSize24 = mockComponent(
    'CrossCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CrossCircleOutlinedSize16 = mockComponent(
    'CrossCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CrossCircleOutlinedSize24 = mockComponent(
    'CrossCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CrossOutlinedSize16 = mockComponent(
    'CrossOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CrossOutlinedSize24 = mockComponent(
    'CrossOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CubeFilledSize16 = mockComponent(
    'CubeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CubeFilledSize24 = mockComponent(
    'CubeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CubeOutlinedSize16 = mockComponent(
    'CubeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CubeOutlinedSize24 = mockComponent(
    'CubeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DashedSquareInOutlinedSize16 = mockComponent(
    'DashedSquareInOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DashedSquareInOutlinedSize24 = mockComponent(
    'DashedSquareInOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DashedSquareOutOutlinedSize16 = mockComponent(
    'DashedSquareOutOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DashedSquareOutOutlinedSize24 = mockComponent(
    'DashedSquareOutOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DataflowFilledSize16 = mockComponent(
    'DataflowFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DataflowFilledSize24 = mockComponent(
    'DataflowFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DataflowOutlinedSize16 = mockComponent(
    'DataflowOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DataflowOutlinedSize24 = mockComponent(
    'DataflowOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentArrowUpFilledSize16 = mockComponent(
    'DocumentArrowUpFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentArrowUpFilledSize24 = mockComponent(
    'DocumentArrowUpFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentArrowUpFilledSize32 = mockComponent(
    'DocumentArrowUpFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentArrowUpOutlinedSize16 = mockComponent(
    'DocumentArrowUpOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentArrowUpOutlinedSize24 = mockComponent(
    'DocumentArrowUpOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentArrowUpOutlinedSize32 = mockComponent(
    'DocumentArrowUpOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentFilledSize16 = mockComponent(
    'DocumentFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentFilledSize24 = mockComponent(
    'DocumentFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentFilledSize32 = mockComponent(
    'DocumentFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentOutlinedSize16 = mockComponent(
    'DocumentOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentOutlinedSize24 = mockComponent(
    'DocumentOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentOutlinedSize32 = mockComponent(
    'DocumentOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentStarFilledSize16 = mockComponent(
    'DocumentStarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentStarFilledSize24 = mockComponent(
    'DocumentStarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentStarFilledSize32 = mockComponent(
    'DocumentStarFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentStarOutlinedSize16 = mockComponent(
    'DocumentStarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentStarOutlinedSize24 = mockComponent(
    'DocumentStarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentStarOutlinedSize32 = mockComponent(
    'DocumentStarOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentVerifiedFilledSize16 = mockComponent(
    'DocumentVerifiedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentVerifiedFilledSize24 = mockComponent(
    'DocumentVerifiedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentVerifiedFilledSize32 = mockComponent(
    'DocumentVerifiedFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentVerifiedOutlinedSize16 = mockComponent(
    'DocumentVerifiedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentVerifiedOutlinedSize24 = mockComponent(
    'DocumentVerifiedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DocumentVerifiedOutlinedSize32 = mockComponent(
    'DocumentVerifiedOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DotFilledSize16 = mockComponent(
    'DotFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DotFilledSize24 = mockComponent(
    'DotFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DotsOutlinedSize16 = mockComponent(
    'DotsOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DotsOutlinedSize24 = mockComponent(
    'DotsOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DrawerFilledSize16 = mockComponent(
    'DrawerFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DrawerFilledSize24 = mockComponent(
    'DrawerFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DrawerOutlinedSize16 = mockComponent(
    'DrawerOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DrawerOutlinedSize24 = mockComponent(
    'DrawerOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DropsFilledSize16 = mockComponent(
    'DropsFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DropsFilledSize24 = mockComponent(
    'DropsFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DropsOutlinedSize16 = mockComponent(
    'DropsOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DropsOutlinedSize24 = mockComponent(
    'DropsOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EllipsisHorizontalCircleFilledSize16 = mockComponent(
    'EllipsisHorizontalCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EllipsisHorizontalCircleFilledSize24 = mockComponent(
    'EllipsisHorizontalCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EllipsisHorizontalCircleOutlinedSize16 = mockComponent(
    'EllipsisHorizontalCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EllipsisHorizontalCircleOutlinedSize24 = mockComponent(
    'EllipsisHorizontalCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EllipsisHorizontalOutlinedSize16 = mockComponent(
    'EllipsisHorizontalOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EllipsisHorizontalOutlinedSize24 = mockComponent(
    'EllipsisHorizontalOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EllipsisVerticalOutlinedSize16 = mockComponent(
    'EllipsisVerticalOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EllipsisVerticalOutlinedSize24 = mockComponent(
    'EllipsisVerticalOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsad3dSize16 = mockComponent(
    'EmojiHalfsad3dSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsad3dSize24 = mockComponent(
    'EmojiHalfsad3dSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsad3dSize32 = mockComponent(
    'EmojiHalfsad3dSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsadFilledSize16 = mockComponent(
    'EmojiHalfsadFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsadFilledSize24 = mockComponent(
    'EmojiHalfsadFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsadFilledSize32 = mockComponent(
    'EmojiHalfsadFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsadOutlinedSize16 = mockComponent(
    'EmojiHalfsadOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsadOutlinedSize24 = mockComponent(
    'EmojiHalfsadOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsadOutlinedSize32 = mockComponent(
    'EmojiHalfsadOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsmile3dSize16 = mockComponent(
    'EmojiHalfsmile3dSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsmile3dSize24 = mockComponent(
    'EmojiHalfsmile3dSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsmile3dSize32 = mockComponent(
    'EmojiHalfsmile3dSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsmileFilledSize16 = mockComponent(
    'EmojiHalfsmileFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsmileFilledSize24 = mockComponent(
    'EmojiHalfsmileFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsmileFilledSize32 = mockComponent(
    'EmojiHalfsmileFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsmileOutlinedSize16 = mockComponent(
    'EmojiHalfsmileOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsmileOutlinedSize24 = mockComponent(
    'EmojiHalfsmileOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiHalfsmileOutlinedSize32 = mockComponent(
    'EmojiHalfsmileOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiNeutral3dSize16 = mockComponent(
    'EmojiNeutral3dSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiNeutral3dSize24 = mockComponent(
    'EmojiNeutral3dSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiNeutral3dSize32 = mockComponent(
    'EmojiNeutral3dSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiNeutralFilledSize16 = mockComponent(
    'EmojiNeutralFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiNeutralFilledSize24 = mockComponent(
    'EmojiNeutralFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiNeutralFilledSize32 = mockComponent(
    'EmojiNeutralFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiNeutralOutlinedSize16 = mockComponent(
    'EmojiNeutralOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiNeutralOutlinedSize24 = mockComponent(
    'EmojiNeutralOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiNeutralOutlinedSize32 = mockComponent(
    'EmojiNeutralOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSad3dSize16 = mockComponent(
    'EmojiSad3dSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSad3dSize24 = mockComponent(
    'EmojiSad3dSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSad3dSize32 = mockComponent(
    'EmojiSad3dSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSadFilledSize16 = mockComponent(
    'EmojiSadFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSadFilledSize24 = mockComponent(
    'EmojiSadFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSadFilledSize32 = mockComponent(
    'EmojiSadFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSadOutlinedSize16 = mockComponent(
    'EmojiSadOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSadOutlinedSize24 = mockComponent(
    'EmojiSadOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSadOutlinedSize32 = mockComponent(
    'EmojiSadOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSmile3dSize16 = mockComponent(
    'EmojiSmile3dSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSmile3dSize24 = mockComponent(
    'EmojiSmile3dSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSmile3dSize32 = mockComponent(
    'EmojiSmile3dSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSmileFilledSize16 = mockComponent(
    'EmojiSmileFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSmileFilledSize24 = mockComponent(
    'EmojiSmileFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSmileFilledSize32 = mockComponent(
    'EmojiSmileFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSmileOutlinedSize16 = mockComponent(
    'EmojiSmileOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSmileOutlinedSize24 = mockComponent(
    'EmojiSmileOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmojiSmileOutlinedSize32 = mockComponent(
    'EmojiSmileOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmptySize16 = mockComponent(
    'EmptySize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmptySize24 = mockComponent(
    'EmptySize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmptySize32 = mockComponent(
    'EmptySize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmptySize48 = mockComponent(
    'EmptySize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmptySize64 = mockComponent(
    'EmptySize64',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmptySize96 = mockComponent(
    'EmptySize96',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EnvelopeFilledSize16 = mockComponent(
    'EnvelopeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EnvelopeFilledSize24 = mockComponent(
    'EnvelopeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EnvelopeOpenedFilledSize16 = mockComponent(
    'EnvelopeOpenedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EnvelopeOpenedFilledSize24 = mockComponent(
    'EnvelopeOpenedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EnvelopeOpenedOutlinedSize16 = mockComponent(
    'EnvelopeOpenedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EnvelopeOpenedOutlinedSize24 = mockComponent(
    'EnvelopeOpenedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EnvelopeOutlinedSize16 = mockComponent(
    'EnvelopeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EnvelopeOutlinedSize24 = mockComponent(
    'EnvelopeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ExclamationCircleFilledSize16 = mockComponent(
    'ExclamationCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ExclamationCircleFilledSize24 = mockComponent(
    'ExclamationCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ExclamationCircleOutlinedSize16 = mockComponent(
    'ExclamationCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ExclamationCircleOutlinedSize24 = mockComponent(
    'ExclamationCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ExclamationTriangleFilledSize16 = mockComponent(
    'ExclamationTriangleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ExclamationTriangleFilledSize24 = mockComponent(
    'ExclamationTriangleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ExclamationTriangleFilledSize32 = mockComponent(
    'ExclamationTriangleFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ExclamationTriangleOutlinedSize16 = mockComponent(
    'ExclamationTriangleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ExclamationTriangleOutlinedSize24 = mockComponent(
    'ExclamationTriangleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ExclamationTriangleOutlinedSize32 = mockComponent(
    'ExclamationTriangleOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EyeCrossedFilledSize16 = mockComponent(
    'EyeCrossedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EyeCrossedFilledSize24 = mockComponent(
    'EyeCrossedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EyeCrossedOutlinedSize16 = mockComponent(
    'EyeCrossedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EyeCrossedOutlinedSize24 = mockComponent(
    'EyeCrossedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EyeFilledSize16 = mockComponent(
    'EyeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EyeFilledSize24 = mockComponent(
    'EyeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EyeOutlinedSize16 = mockComponent(
    'EyeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EyeOutlinedSize24 = mockComponent(
    'EyeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlagFilledSize16 = mockComponent(
    'FlagFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlagFilledSize24 = mockComponent(
    'FlagFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlagOutlinedSize16 = mockComponent(
    'FlagOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlagOutlinedSize24 = mockComponent(
    'FlagOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlameFilledSize16 = mockComponent(
    'FlameFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlameFilledSize24 = mockComponent(
    'FlameFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlameFilledSize32 = mockComponent(
    'FlameFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlameOutlinedSize16 = mockComponent(
    'FlameOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlameOutlinedSize24 = mockComponent(
    'FlameOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlameOutlinedSize32 = mockComponent(
    'FlameOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlaskFilledSize16 = mockComponent(
    'FlaskFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlaskFilledSize24 = mockComponent(
    'FlaskFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlaskOutlinedSize16 = mockComponent(
    'FlaskOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FlaskOutlinedSize24 = mockComponent(
    'FlaskOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderArrowRightFilledSize16 = mockComponent(
    'FolderArrowRightFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderArrowRightFilledSize24 = mockComponent(
    'FolderArrowRightFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderArrowRightOutlinedSize16 = mockComponent(
    'FolderArrowRightOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderArrowRightOutlinedSize24 = mockComponent(
    'FolderArrowRightOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderFilledSize16 = mockComponent(
    'FolderFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderFilledSize24 = mockComponent(
    'FolderFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderHeartFilledSize16 = mockComponent(
    'FolderHeartFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderHeartFilledSize24 = mockComponent(
    'FolderHeartFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderHeartOutlinedSize16 = mockComponent(
    'FolderHeartOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderHeartOutlinedSize24 = mockComponent(
    'FolderHeartOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderHyperstarFilledSize16 = mockComponent(
    'FolderHyperstarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderHyperstarFilledSize24 = mockComponent(
    'FolderHyperstarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderHyperstarOutlinedSize16 = mockComponent(
    'FolderHyperstarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderHyperstarOutlinedSize24 = mockComponent(
    'FolderHyperstarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderOutlinedSize16 = mockComponent(
    'FolderOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FolderOutlinedSize24 = mockComponent(
    'FolderOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ForwardFilledSize16 = mockComponent(
    'ForwardFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ForwardFilledSize24 = mockComponent(
    'ForwardFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ForwardOutlinedSize16 = mockComponent(
    'ForwardOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ForwardOutlinedSize24 = mockComponent(
    'ForwardOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FrameStarFilledSize16 = mockComponent(
    'FrameStarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FrameStarFilledSize24 = mockComponent(
    'FrameStarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FrameStarOutlinedSize16 = mockComponent(
    'FrameStarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FrameStarOutlinedSize24 = mockComponent(
    'FrameStarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FunnelFilledSize16 = mockComponent(
    'FunnelFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FunnelFilledSize24 = mockComponent(
    'FunnelFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FunnelOutlinedSize16 = mockComponent(
    'FunnelOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const FunnelOutlinedSize24 = mockComponent(
    'FunnelOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GamepadFilledSize16 = mockComponent(
    'GamepadFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GamepadFilledSize24 = mockComponent(
    'GamepadFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GamepadOutlinedSize16 = mockComponent(
    'GamepadOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GamepadOutlinedSize24 = mockComponent(
    'GamepadOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GearFilledSize16 = mockComponent(
    'GearFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GearFilledSize24 = mockComponent(
    'GearFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GearOutlinedSize16 = mockComponent(
    'GearOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GearOutlinedSize24 = mockComponent(
    'GearOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GhostFilledSize16 = mockComponent(
    'GhostFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GhostFilledSize24 = mockComponent(
    'GhostFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GhostOutlinedSize16 = mockComponent(
    'GhostOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GhostOutlinedSize24 = mockComponent(
    'GhostOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GiftFilledSize16 = mockComponent(
    'GiftFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GiftFilledSize24 = mockComponent(
    'GiftFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GiftOutlinedSize16 = mockComponent(
    'GiftOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GiftOutlinedSize24 = mockComponent(
    'GiftOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GlobeFilledSize16 = mockComponent(
    'GlobeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GlobeFilledSize24 = mockComponent(
    'GlobeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GlobeOutlinedSize16 = mockComponent(
    'GlobeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GlobeOutlinedSize24 = mockComponent(
    'GlobeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GraduationHatFilledSize16 = mockComponent(
    'GraduationHatFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GraduationHatFilledSize24 = mockComponent(
    'GraduationHatFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GraduationHatFilledSize32 = mockComponent(
    'GraduationHatFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GraduationHatOutlinedSize16 = mockComponent(
    'GraduationHatOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GraduationHatOutlinedSize24 = mockComponent(
    'GraduationHatOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GraduationHatOutlinedSize32 = mockComponent(
    'GraduationHatOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GridFilledSize16 = mockComponent(
    'GridFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GridFilledSize24 = mockComponent(
    'GridFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GridOutlinedSize16 = mockComponent(
    'GridOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const GridOutlinedSize24 = mockComponent(
    'GridOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HeadsetFilledSize16 = mockComponent(
    'HeadsetFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HeadsetFilledSize24 = mockComponent(
    'HeadsetFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HeadsetOutlinedSize16 = mockComponent(
    'HeadsetOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HeadsetOutlinedSize24 = mockComponent(
    'HeadsetOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HeartFilledSize16 = mockComponent(
    'HeartFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HeartFilledSize24 = mockComponent(
    'HeartFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HeartFilledSize32 = mockComponent(
    'HeartFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HeartOutlinedSize16 = mockComponent(
    'HeartOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HeartOutlinedSize24 = mockComponent(
    'HeartOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HeartOutlinedSize32 = mockComponent(
    'HeartOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HieroglyphLetterOutlinedSize16 = mockComponent(
    'HieroglyphLetterOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HieroglyphLetterOutlinedSize24 = mockComponent(
    'HieroglyphLetterOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HomeFilledSize16 = mockComponent(
    'HomeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HomeFilledSize24 = mockComponent(
    'HomeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HomeOutlinedSize16 = mockComponent(
    'HomeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HomeOutlinedSize24 = mockComponent(
    'HomeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HumanCircleFilledSize16 = mockComponent(
    'HumanCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HumanCircleFilledSize24 = mockComponent(
    'HumanCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HumanCircleOutlinedSize16 = mockComponent(
    'HumanCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HumanCircleOutlinedSize24 = mockComponent(
    'HumanCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HumanWalkFilledSize16 = mockComponent(
    'HumanWalkFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HumanWalkFilledSize24 = mockComponent(
    'HumanWalkFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarFilledSize16 = mockComponent(
    'HyperstarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarFilledSize24 = mockComponent(
    'HyperstarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarFilledSize32 = mockComponent(
    'HyperstarFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarFilledSize48 = mockComponent(
    'HyperstarFilledSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarOutlinedSize16 = mockComponent(
    'HyperstarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarOutlinedSize24 = mockComponent(
    'HyperstarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarOutlinedSize32 = mockComponent(
    'HyperstarOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarOutlinedSize48 = mockComponent(
    'HyperstarOutlinedSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarSparkleFilledSize16 = mockComponent(
    'HyperstarSparkleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarSparkleFilledSize24 = mockComponent(
    'HyperstarSparkleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarSparkleFilledSize32 = mockComponent(
    'HyperstarSparkleFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarSparkleFilledSize48 = mockComponent(
    'HyperstarSparkleFilledSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarSparkleOutlinedSize16 = mockComponent(
    'HyperstarSparkleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarSparkleOutlinedSize24 = mockComponent(
    'HyperstarSparkleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarSparkleOutlinedSize32 = mockComponent(
    'HyperstarSparkleOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HyperstarSparkleOutlinedSize48 = mockComponent(
    'HyperstarSparkleOutlinedSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageFilledSize16 = mockComponent(
    'ImageFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageFilledSize24 = mockComponent(
    'ImageFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageFilledSize32 = mockComponent(
    'ImageFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageFilledSize48 = mockComponent(
    'ImageFilledSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageHyperstarFilledSize16 = mockComponent(
    'ImageHyperstarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageHyperstarFilledSize24 = mockComponent(
    'ImageHyperstarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageHyperstarOutlinedSize16 = mockComponent(
    'ImageHyperstarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageHyperstarOutlinedSize24 = mockComponent(
    'ImageHyperstarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageOutlinedSize16 = mockComponent(
    'ImageOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageOutlinedSize24 = mockComponent(
    'ImageOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageOutlinedSize32 = mockComponent(
    'ImageOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageOutlinedSize48 = mockComponent(
    'ImageOutlinedSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageStackFilledSize16 = mockComponent(
    'ImageStackFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageStackFilledSize32 = mockComponent(
    'ImageStackFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageStackFilledSizeSize4 = mockComponent(
    'ImageStackFilledSizeSize4',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageStackOutlinedSize16 = mockComponent(
    'ImageStackOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageStackOutlinedSize24 = mockComponent(
    'ImageStackOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ImageStackOutlinedSize32 = mockComponent(
    'ImageStackOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const InfoCircleFilledSize16 = mockComponent(
    'InfoCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const InfoCircleFilledSize24 = mockComponent(
    'InfoCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const InfoCircleOutlinedSize16 = mockComponent(
    'InfoCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const InfoCircleOutlinedSize24 = mockComponent(
    'InfoCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IngotsFilledSize16 = mockComponent(
    'IngotsFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IngotsFilledSize24 = mockComponent(
    'IngotsFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IngotsOutlinedSize16 = mockComponent(
    'IngotsOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const IngotsOutlinedSize24 = mockComponent(
    'IngotsOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const KeyFilledSize16 = mockComponent(
    'KeyFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const KeyFilledSize24 = mockComponent(
    'KeyFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const KeyOutlinedSize16 = mockComponent(
    'KeyOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const KeyOutlinedSize24 = mockComponent(
    'KeyOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LiferingFilledSize16 = mockComponent(
    'LiferingFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LiferingFilledSize24 = mockComponent(
    'LiferingFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LiferingOutlinedSize16 = mockComponent(
    'LiferingOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LiferingOutlinedSize24 = mockComponent(
    'LiferingOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LightbulbOnFilledSize16 = mockComponent(
    'LightbulbOnFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LightbulbOnFilledSize24 = mockComponent(
    'LightbulbOnFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LightbulbOnOutlinedSize16 = mockComponent(
    'LightbulbOnOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LightbulbOnOutlinedSize24 = mockComponent(
    'LightbulbOnOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LineArrowRightEnterOutlinedSize16 = mockComponent(
    'LineArrowRightEnterOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LineArrowRightEnterOutlinedSize24 = mockComponent(
    'LineArrowRightEnterOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LineArrowRightOutlinedSize16 = mockComponent(
    'LineArrowRightOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LineArrowRightOutlinedSize24 = mockComponent(
    'LineArrowRightOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LinkOutlinedSize16 = mockComponent(
    'LinkOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LinkOutlinedSize24 = mockComponent(
    'LinkOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ListOutlinedSize16 = mockComponent(
    'ListOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ListOutlinedSize24 = mockComponent(
    'ListOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ListShortOutlinedSize16 = mockComponent(
    'ListShortOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ListShortOutlinedSize24 = mockComponent(
    'ListShortOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LoaderOutlinedSize16 = mockComponent(
    'LoaderOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LoaderOutlinedSize24 = mockComponent(
    'LoaderOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LoaderOutlinedSize32 = mockComponent(
    'LoaderOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LoaderOutlinedSize48 = mockComponent(
    'LoaderOutlinedSize48',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LoaderOutlinedSize64 = mockComponent(
    'LoaderOutlinedSize64',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LoaderOutlinedSize96 = mockComponent(
    'LoaderOutlinedSize96',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LocationFilledSize16 = mockComponent(
    'LocationFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LocationFilledSize24 = mockComponent(
    'LocationFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LocationFilledSize32 = mockComponent(
    'LocationFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LocationOutlinedSize16 = mockComponent(
    'LocationOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LocationOutlinedSize24 = mockComponent(
    'LocationOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LocationOutlinedSize32 = mockComponent(
    'LocationOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockClosedFilledSize12 = mockComponent(
    'LockClosedFilledSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockClosedFilledSize16 = mockComponent(
    'LockClosedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockClosedFilledSize24 = mockComponent(
    'LockClosedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockClosedOutlinedSize12 = mockComponent(
    'LockClosedOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockClosedOutlinedSize16 = mockComponent(
    'LockClosedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockClosedOutlinedSize24 = mockComponent(
    'LockClosedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockOpenedFilledSize12 = mockComponent(
    'LockOpenedFilledSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockOpenedFilledSize16 = mockComponent(
    'LockOpenedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockOpenedFilledSize24 = mockComponent(
    'LockOpenedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockOpenedOutlinedSize12 = mockComponent(
    'LockOpenedOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockOpenedOutlinedSize16 = mockComponent(
    'LockOpenedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LockOpenedOutlinedSize24 = mockComponent(
    'LockOpenedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierFilledHeartFilledSize16 = mockComponent(
    'MagnifierFilledHeartFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierFilledHeartFilledSize24 = mockComponent(
    'MagnifierFilledHeartFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierFilledHeartOutlinedSize16 = mockComponent(
    'MagnifierFilledHeartOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierFilledHeartOutlinedSize24 = mockComponent(
    'MagnifierFilledHeartOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierFilledHyperstarFilledSize16 = mockComponent(
    'MagnifierFilledHyperstarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierFilledHyperstarFilledSize24 = mockComponent(
    'MagnifierFilledHyperstarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierFilledSize16 = mockComponent(
    'MagnifierFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierFilledSize24 = mockComponent(
    'MagnifierFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierMinusFilledSize16 = mockComponent(
    'MagnifierMinusFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierMinusFilledSize24 = mockComponent(
    'MagnifierMinusFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierMinusOutlinedSize16 = mockComponent(
    'MagnifierMinusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierMinusOutlinedSize24 = mockComponent(
    'MagnifierMinusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierOutlinedHeartFilledSize16 = mockComponent(
    'MagnifierOutlinedHeartFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierOutlinedHeartFilledSize24 = mockComponent(
    'MagnifierOutlinedHeartFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierOutlinedHeartOutlinedSize16 = mockComponent(
    'MagnifierOutlinedHeartOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierOutlinedHeartOutlinedSize24 = mockComponent(
    'MagnifierOutlinedHeartOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierOutlinedHyperstarFilledSize16 = mockComponent(
    'MagnifierOutlinedHyperstarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierOutlinedHyperstarFilledSize24 = mockComponent(
    'MagnifierOutlinedHyperstarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierOutlinedSize16 = mockComponent(
    'MagnifierOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierOutlinedSize24 = mockComponent(
    'MagnifierOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierPlusFilledSize16 = mockComponent(
    'MagnifierPlusFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierPlusFilledSize24 = mockComponent(
    'MagnifierPlusFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierPlusOutlinedSize16 = mockComponent(
    'MagnifierPlusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MagnifierPlusOutlinedSize24 = mockComponent(
    'MagnifierPlusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapFilledSize16 = mockComponent(
    'MapFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapFilledSize24 = mockComponent(
    'MapFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapFilledSize32 = mockComponent(
    'MapFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapOutlinedSize16 = mockComponent(
    'MapOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapOutlinedSize24 = mockComponent(
    'MapOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapOutlinedSize32 = mockComponent(
    'MapOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapPinFilledSize16 = mockComponent(
    'MapPinFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapPinFilledSize24 = mockComponent(
    'MapPinFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapPinFilledSize32 = mockComponent(
    'MapPinFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapPinOutlinedSize16 = mockComponent(
    'MapPinOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapPinOutlinedSize24 = mockComponent(
    'MapPinOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MapPinOutlinedSize32 = mockComponent(
    'MapPinOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MegaphoneFilledSize16 = mockComponent(
    'MegaphoneFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MegaphoneFilledSize24 = mockComponent(
    'MegaphoneFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MegaphoneOutlinedSize16 = mockComponent(
    'MegaphoneOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MegaphoneOutlinedSize24 = mockComponent(
    'MegaphoneOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MicCrossedFilledSize16 = mockComponent(
    'MicCrossedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MicCrossedFilledSize24 = mockComponent(
    'MicCrossedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MicCrossedOutlinedSize16 = mockComponent(
    'MicCrossedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MicCrossedOutlinedSize24 = mockComponent(
    'MicCrossedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MicFilledSize16 = mockComponent(
    'MicFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MicFilledSize24 = mockComponent(
    'MicFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MicOutlinedSize16 = mockComponent(
    'MicOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MicOutlinedSize24 = mockComponent(
    'MicOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MinusCircleFilledSize16 = mockComponent(
    'MinusCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MinusCircleFilledSize24 = mockComponent(
    'MinusCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MinusCircleOutlinedSize16 = mockComponent(
    'MinusCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MinusCircleOutlinedSize24 = mockComponent(
    'MinusCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MinusOutlinedSize16 = mockComponent(
    'MinusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MinusOutlinedSize24 = mockComponent(
    'MinusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MoonStarFilledSize16 = mockComponent(
    'MoonStarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MoonStarFilledSize24 = mockComponent(
    'MoonStarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MoonStarOutlinedSize16 = mockComponent(
    'MoonStarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const MoonStarOutlinedSize24 = mockComponent(
    'MoonStarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PauseFilledSize16 = mockComponent(
    'PauseFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PauseFilledSize24 = mockComponent(
    'PauseFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PauseOutlinedSize16 = mockComponent(
    'PauseOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PauseOutlinedSize24 = mockComponent(
    'PauseOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenFilledSize12 = mockComponent(
    'PenFilledSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenFilledSize16 = mockComponent(
    'PenFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenFilledSize24 = mockComponent(
    'PenFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenHyperstarFilledSize16 = mockComponent(
    'PenHyperstarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenHyperstarFilledSize24 = mockComponent(
    'PenHyperstarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenHyperstarOutlinedSize16 = mockComponent(
    'PenHyperstarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenHyperstarOutlinedSize24 = mockComponent(
    'PenHyperstarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenLineFilledSize16 = mockComponent(
    'PenLineFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenLineFilledSize24 = mockComponent(
    'PenLineFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenLineOutlinedSize16 = mockComponent(
    'PenLineOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenLineOutlinedSize24 = mockComponent(
    'PenLineOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenOutlinedSize12 = mockComponent(
    'PenOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenOutlinedSize16 = mockComponent(
    'PenOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenOutlinedSize24 = mockComponent(
    'PenOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenSquareOutlinedSize16 = mockComponent(
    'PenSquareOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PenSquareOutlinedSize24 = mockComponent(
    'PenSquareOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneArrowInFilledSize16 = mockComponent(
    'PhoneArrowInFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneArrowInFilledSize24 = mockComponent(
    'PhoneArrowInFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneArrowInOutlinedSize16 = mockComponent(
    'PhoneArrowInOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneArrowInOutlinedSize24 = mockComponent(
    'PhoneArrowInOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneArrowOutFilledSize16 = mockComponent(
    'PhoneArrowOutFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneArrowOutFilledSize24 = mockComponent(
    'PhoneArrowOutFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneArrowOutOutlinedSize16 = mockComponent(
    'PhoneArrowOutOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneArrowOutOutlinedSize24 = mockComponent(
    'PhoneArrowOutOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneCrossFilledSize16 = mockComponent(
    'PhoneCrossFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneCrossFilledSize24 = mockComponent(
    'PhoneCrossFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneCrossOutlinedSize16 = mockComponent(
    'PhoneCrossOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneCrossOutlinedSize24 = mockComponent(
    'PhoneCrossOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneDownFilledSize16 = mockComponent(
    'PhoneDownFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneDownFilledSize24 = mockComponent(
    'PhoneDownFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneDownOutlinedSize16 = mockComponent(
    'PhoneDownOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneDownOutlinedSize24 = mockComponent(
    'PhoneDownOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneFilledSize16 = mockComponent(
    'PhoneFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneFilledSize24 = mockComponent(
    'PhoneFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneOutlinedSize16 = mockComponent(
    'PhoneOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneOutlinedSize24 = mockComponent(
    'PhoneOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneWaveFilledSize16 = mockComponent(
    'PhoneWaveFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneWaveFilledSize24 = mockComponent(
    'PhoneWaveFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneWaveOutlinedSize16 = mockComponent(
    'PhoneWaveOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PhoneWaveOutlinedSize24 = mockComponent(
    'PhoneWaveOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PinCrossedFilledSize16 = mockComponent(
    'PinCrossedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PinCrossedFilledSize24 = mockComponent(
    'PinCrossedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PinCrossedOutlinedSize16 = mockComponent(
    'PinCrossedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PinCrossedOutlinedSize24 = mockComponent(
    'PinCrossedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PinFilledSize16 = mockComponent(
    'PinFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PinFilledSize24 = mockComponent(
    'PinFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PinOutlinedSize16 = mockComponent(
    'PinOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PinOutlinedSize24 = mockComponent(
    'PinOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlayCircleFilledSize16 = mockComponent(
    'PlayCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlayCircleFilledSize24 = mockComponent(
    'PlayCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlayCircleOutlinedSize16 = mockComponent(
    'PlayCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlayCircleOutlinedSize24 = mockComponent(
    'PlayCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlayFilledSize16 = mockComponent(
    'PlayFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlayFilledSize24 = mockComponent(
    'PlayFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlayOutlinedSize16 = mockComponent(
    'PlayOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlayOutlinedSize24 = mockComponent(
    'PlayOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlusBoldFilledSize16 = mockComponent(
    'PlusBoldFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlusBoldFilledSize24 = mockComponent(
    'PlusBoldFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlusBoldOutlinedSize16 = mockComponent(
    'PlusBoldOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlusBoldOutlinedSize24 = mockComponent(
    'PlusBoldOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlusCircleFilledSize16 = mockComponent(
    'PlusCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlusCircleFilledSize24 = mockComponent(
    'PlusCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlusCircleOutlinedSize16 = mockComponent(
    'PlusCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlusCircleOutlinedSize24 = mockComponent(
    'PlusCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlusOutlinedSize16 = mockComponent(
    'PlusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PlusOutlinedSize24 = mockComponent(
    'PlusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PopcornFilledSize16 = mockComponent(
    'PopcornFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PopcornFilledSize24 = mockComponent(
    'PopcornFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PopcornOutlinedSize16 = mockComponent(
    'PopcornOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PopcornOutlinedSize24 = mockComponent(
    'PopcornOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PriceTagFilledSize16 = mockComponent(
    'PriceTagFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PriceTagFilledSize24 = mockComponent(
    'PriceTagFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PriceTagOutlinedSize16 = mockComponent(
    'PriceTagOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PriceTagOutlinedSize24 = mockComponent(
    'PriceTagOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PrinterFilledSize16 = mockComponent(
    'PrinterFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PrinterFilledSize24 = mockComponent(
    'PrinterFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PrinterOutlinedSize16 = mockComponent(
    'PrinterOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const PrinterOutlinedSize24 = mockComponent(
    'PrinterOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const QrCodeOutlinedSize16 = mockComponent(
    'QrCodeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const QrCodeOutlinedSize24 = mockComponent(
    'QrCodeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const QuestionCircleFilledSize16 = mockComponent(
    'QuestionCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const QuestionCircleFilledSize24 = mockComponent(
    'QuestionCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const QuestionCircleOutlinedSize16 = mockComponent(
    'QuestionCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const QuestionCircleOutlinedSize24 = mockComponent(
    'QuestionCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RadiusFilledSize16 = mockComponent(
    'RadiusFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RadiusFilledSize24 = mockComponent(
    'RadiusFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RadiusOutlinedSize16 = mockComponent(
    'RadiusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RadiusOutlinedSize24 = mockComponent(
    'RadiusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RocketFilledSize16 = mockComponent(
    'RocketFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RocketFilledSize24 = mockComponent(
    'RocketFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RocketOutlinedSize16 = mockComponent(
    'RocketOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RocketOutlinedSize24 = mockComponent(
    'RocketOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RotateLeftFilledSize16 = mockComponent(
    'RotateLeftFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RotateLeftFilledSize24 = mockComponent(
    'RotateLeftFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RotateLeftOultinedSize16 = mockComponent(
    'RotateLeftOultinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RotateLeftOultinedSize24 = mockComponent(
    'RotateLeftOultinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RotateRightFilledSize16 = mockComponent(
    'RotateRightFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RotateRightFilledSize24 = mockComponent(
    'RotateRightFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RotateRightOutlinedSize16 = mockComponent(
    'RotateRightOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const RotateRightOutlinedSize24 = mockComponent(
    'RotateRightOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SafeFilledSize16 = mockComponent(
    'SafeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SafeFilledSize24 = mockComponent(
    'SafeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SafeOutlinedSize16 = mockComponent(
    'SafeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SafeOutlinedSize24 = mockComponent(
    'SafeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ScooterFilledSize16 = mockComponent(
    'ScooterFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ScooterFilledSize24 = mockComponent(
    'ScooterFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ScooterOutlinedSize16 = mockComponent(
    'ScooterOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ScooterOutlinedSize24 = mockComponent(
    'ScooterOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendAndroidFilledSize16 = mockComponent(
    'SendAndroidFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendAndroidFilledSize24 = mockComponent(
    'SendAndroidFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendAndroidFilledSize32 = mockComponent(
    'SendAndroidFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendAndroidOutlinedSize16 = mockComponent(
    'SendAndroidOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendAndroidOutlinedSize24 = mockComponent(
    'SendAndroidOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendAndroidOutlinedSize32 = mockComponent(
    'SendAndroidOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendIosFilledSize16 = mockComponent(
    'SendIosFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendIosFilledSize24 = mockComponent(
    'SendIosFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendIosFilledSize32 = mockComponent(
    'SendIosFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendIosOutlinedSize16 = mockComponent(
    'SendIosOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendIosOutlinedSize24 = mockComponent(
    'SendIosOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendIosOutlinedSize32 = mockComponent(
    'SendIosOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendWebFilledSize16 = mockComponent(
    'SendWebFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendWebFilledSize24 = mockComponent(
    'SendWebFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendWebFilledSize32 = mockComponent(
    'SendWebFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendWebOutlinedSize16 = mockComponent(
    'SendWebOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendWebOutlinedSize24 = mockComponent(
    'SendWebOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SendWebOutlinedSize32 = mockComponent(
    'SendWebOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShareAndroidOutlinedSize16 = mockComponent(
    'ShareAndroidOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShareAndroidOutlinedSize24 = mockComponent(
    'ShareAndroidOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShareIosOutlinedSize16 = mockComponent(
    'ShareIosOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShareIosOutlinedSize24 = mockComponent(
    'ShareIosOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShareWebFilledSize16 = mockComponent(
    'ShareWebFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShareWebFilledSize24 = mockComponent(
    'ShareWebFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShareWebOutlinedSize16 = mockComponent(
    'ShareWebOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShareWebOutlinedSize24 = mockComponent(
    'ShareWebOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShieldFilledSize16 = mockComponent(
    'ShieldFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShieldFilledSize24 = mockComponent(
    'ShieldFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShieldOutlinedSize16 = mockComponent(
    'ShieldOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ShieldOutlinedSize24 = mockComponent(
    'ShieldOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SmartphoneFilledSize16 = mockComponent(
    'SmartphoneFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SmartphoneFilledSize24 = mockComponent(
    'SmartphoneFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SmartphoneOutlinedSize16 = mockComponent(
    'SmartphoneOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SmartphoneOutlinedSize24 = mockComponent(
    'SmartphoneOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SmileFaceFilledSize16 = mockComponent(
    'SmileFaceFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SmileFaceFilledSize24 = mockComponent(
    'SmileFaceFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SmileFaceOutlinedSize16 = mockComponent(
    'SmileFaceOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SmileFaceOutlinedSize24 = mockComponent(
    'SmileFaceOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerCrossFilledSize16 = mockComponent(
    'SpeakerCrossFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerCrossFilledSize24 = mockComponent(
    'SpeakerCrossFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerCrossOutlinedSize16 = mockComponent(
    'SpeakerCrossOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerCrossOutlinedSize24 = mockComponent(
    'SpeakerCrossOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerCrossedFilledSize16 = mockComponent(
    'SpeakerCrossedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerCrossedFilledSize24 = mockComponent(
    'SpeakerCrossedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerCrossedFilledSize32 = mockComponent(
    'SpeakerCrossedFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerCrossedOutlinedSize16 = mockComponent(
    'SpeakerCrossedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerCrossedOutlinedSize24 = mockComponent(
    'SpeakerCrossedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerWaveFilledSize16 = mockComponent(
    'SpeakerWaveFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerWaveFilledSize24 = mockComponent(
    'SpeakerWaveFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerWaveOutlinedSize16 = mockComponent(
    'SpeakerWaveOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeakerWaveOutlinedSize24 = mockComponent(
    'SpeakerWaveOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeedometerFilledSize16 = mockComponent(
    'SpeedometerFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeedometerFilledSize24 = mockComponent(
    'SpeedometerFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeedometerOutlinedSize16 = mockComponent(
    'SpeedometerOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SpeedometerOutlinedSize24 = mockComponent(
    'SpeedometerOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SquareCircleFilledSize16 = mockComponent(
    'SquareCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SquareCircleFilledSize24 = mockComponent(
    'SquareCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SquaresIntersectedFilledSize16 = mockComponent(
    'SquaresIntersectedFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SquaresIntersectedFilledSize24 = mockComponent(
    'SquaresIntersectedFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SquaresIntersectedOutlinedSize16 = mockComponent(
    'SquaresIntersectedOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SquaresIntersectedOutlinedSize24 = mockComponent(
    'SquaresIntersectedOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarCircleFilledSize16 = mockComponent(
    'StarCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarCircleFilledSize24 = mockComponent(
    'StarCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarCircleFilledSize32 = mockComponent(
    'StarCircleFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarCircleOutlinedSize16 = mockComponent(
    'StarCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarCircleOutlinedSize24 = mockComponent(
    'StarCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarCircleOutlinedSize32 = mockComponent(
    'StarCircleOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarFilledSize16 = mockComponent(
    'StarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarFilledSize24 = mockComponent(
    'StarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarFilledSize32 = mockComponent(
    'StarFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarHalfFilledSize16 = mockComponent(
    'StarHalfFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarHalfFilledSize24 = mockComponent(
    'StarHalfFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarHalfFilledSize32 = mockComponent(
    'StarHalfFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarOutlinedSize16 = mockComponent(
    'StarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarOutlinedSize24 = mockComponent(
    'StarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const StarOutlinedSize32 = mockComponent(
    'StarOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SunFilledSize16 = mockComponent(
    'SunFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SunFilledSize24 = mockComponent(
    'SunFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SunOutlinedSize16 = mockComponent(
    'SunOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SunOutlinedSize24 = mockComponent(
    'SunOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SuperstarFilledSize16 = mockComponent(
    'SuperstarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SuperstarFilledSize24 = mockComponent(
    'SuperstarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SuperstarOutlinedSize16 = mockComponent(
    'SuperstarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const SuperstarOutlinedSize24 = mockComponent(
    'SuperstarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ThumbDownFilledSize16 = mockComponent(
    'ThumbDownFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ThumbDownFilledSize24 = mockComponent(
    'ThumbDownFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ThumbDownOutlinedSize16 = mockComponent(
    'ThumbDownOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ThumbDownOutlinedSize24 = mockComponent(
    'ThumbDownOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ThumbUpFilledSize16 = mockComponent(
    'ThumbUpFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ThumbUpFilledSize24 = mockComponent(
    'ThumbUpFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ThumbUpOutlinedSize16 = mockComponent(
    'ThumbUpOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ThumbUpOutlinedSize24 = mockComponent(
    'ThumbUpOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrainFilledSize16 = mockComponent(
    'TrainFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrainFilledSize24 = mockComponent(
    'TrainFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrainOutlinedSize16 = mockComponent(
    'TrainOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrainOutlinedSize24 = mockComponent(
    'TrainOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TramFilledSize16 = mockComponent(
    'TramFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TramFilledSize24 = mockComponent(
    'TramFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TramOutlinedSize16 = mockComponent(
    'TramOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TramOutlinedSize24 = mockComponent(
    'TramOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrashFilledSize16 = mockComponent(
    'TrashFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrashFilledSize24 = mockComponent(
    'TrashFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrashOutlinedSize16 = mockComponent(
    'TrashOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrashOutlinedSize24 = mockComponent(
    'TrashOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TreeFilledSize16 = mockComponent(
    'TreeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TreeFilledSize24 = mockComponent(
    'TreeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TreeOutlinedSize16 = mockComponent(
    'TreeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TreeOutlinedSize24 = mockComponent(
    'TreeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrolleyFilledSize16 = mockComponent(
    'TrolleyFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrolleyFilledSize24 = mockComponent(
    'TrolleyFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrolleyOutlinedSize16 = mockComponent(
    'TrolleyOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrolleyOutlinedSize24 = mockComponent(
    'TrolleyOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrolleybusFilledSize16 = mockComponent(
    'TrolleybusFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrolleybusFilledSize24 = mockComponent(
    'TrolleybusFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrolleybusOutlinedSize16 = mockComponent(
    'TrolleybusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const TrolleybusOutlinedSize24 = mockComponent(
    'TrolleybusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserCircleFilledSize16 = mockComponent(
    'UserCircleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserCircleFilledSize24 = mockComponent(
    'UserCircleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserCircleFilledSize32 = mockComponent(
    'UserCircleFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserCircleOutlinedSize16 = mockComponent(
    'UserCircleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserCircleOutlinedSize24 = mockComponent(
    'UserCircleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserCircleOutlinedSize32 = mockComponent(
    'UserCircleOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserDoubleFilledSize16 = mockComponent(
    'UserDoubleFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserDoubleFilledSize24 = mockComponent(
    'UserDoubleFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserDoubleOutlinedSize16 = mockComponent(
    'UserDoubleOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserDoubleOutlinedSize24 = mockComponent(
    'UserDoubleOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserFilledSize16 = mockComponent(
    'UserFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserFilledSize24 = mockComponent(
    'UserFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserOutlinedSize16 = mockComponent(
    'UserOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserOutlinedSize24 = mockComponent(
    'UserOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserSingleBanFilledSize16 = mockComponent(
    'UserSingleBanFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserSingleBanFilledSize24 = mockComponent(
    'UserSingleBanFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserSingleBanOutlinedSize16 = mockComponent(
    'UserSingleBanOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserSingleBanOutlinedSize24 = mockComponent(
    'UserSingleBanOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserSinglePlusFilledSize16 = mockComponent(
    'UserSinglePlusFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserSinglePlusFilledSize24 = mockComponent(
    'UserSinglePlusFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserSinglePlusOutlinedSize16 = mockComponent(
    'UserSinglePlusOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UserSinglePlusOutlinedSize24 = mockComponent(
    'UserSinglePlusOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UturnLeftOutlinedSize16 = mockComponent(
    'UturnLeftOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UturnLeftOutlinedSize24 = mockComponent(
    'UturnLeftOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UturnRightOutlinedSize16 = mockComponent(
    'UturnRightOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const UturnRightOutlinedSize24 = mockComponent(
    'UturnRightOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VerifiedBadgeFilledSize12 = mockComponent(
    'VerifiedBadgeFilledSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VerifiedBadgeFilledSize16 = mockComponent(
    'VerifiedBadgeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VerifiedBadgeFilledSize24 = mockComponent(
    'VerifiedBadgeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VerifiedBadgeFilledSize32 = mockComponent(
    'VerifiedBadgeFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VerifiedBadgeOutlinedSize12 = mockComponent(
    'VerifiedBadgeOutlinedSize12',
    { _size: undefined, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VerifiedBadgeOutlinedSize16 = mockComponent(
    'VerifiedBadgeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VerifiedBadgeOutlinedSize24 = mockComponent(
    'VerifiedBadgeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VideocameraFilledSize16 = mockComponent(
    'VideocameraFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VideocameraFilledSize24 = mockComponent(
    'VideocameraFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VideocameraFilledSize32 = mockComponent(
    'VideocameraFilledSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VideocameraHyperstarFilledSize16 = mockComponent(
    'VideocameraHyperstarFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VideocameraHyperstarFilledSize24 = mockComponent(
    'VideocameraHyperstarFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VideocameraHyperstarOutlinedSize16 = mockComponent(
    'VideocameraHyperstarOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VideocameraHyperstarOutlinedSize24 = mockComponent(
    'VideocameraHyperstarOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VideocameraOutlinedSize16 = mockComponent(
    'VideocameraOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VideocameraOutlinedSize24 = mockComponent(
    'VideocameraOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const VideocameraOutlinedSize32 = mockComponent(
    'VideocameraOutlinedSize32',
    { _size: 32, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WalletFilledSize16 = mockComponent(
    'WalletFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WalletFilledSize24 = mockComponent(
    'WalletFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WalletOutlinedSize16 = mockComponent(
    'WalletOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WalletOutlinedSize24 = mockComponent(
    'WalletOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WheatFilledSize16 = mockComponent(
    'WheatFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WheatFilledSize24 = mockComponent(
    'WheatFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WheatOutlinedSize16 = mockComponent(
    'WheatOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const WheatOutlinedSize24 = mockComponent(
    'WheatOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);
